import { EventModule } from "app/event/EventModule"
import { COORDINATE_EVENTS, ICoordinate, ICoordinateEventModule } from "./model"

class CoordinateEventModule extends EventModule implements ICoordinateEventModule {
  public on = {
    onCoordinateAdd: (listenerId: string, fn: (coordinate: ICoordinate) => void): void => {
      this.addListenerFn(COORDINATE_EVENTS.COORDINATE_ADD, listenerId, fn)
    },
    onCoordinateUpdate: (listenerId: string, fn: (coordinate: ICoordinate) => void): void => {
      this.addListenerFn(COORDINATE_EVENTS.COORDINATE_UPDATE, listenerId, fn)
    },
    onCoordinateDelete: (listenerId: string, fn: (coordinateId: number) => void): void => {
      this.addListenerFn(COORDINATE_EVENTS.COORDINATE_DELETE, listenerId, fn)
    },
    onCoordinatesDelete: (listenerId: string, fn: (coordinateIds: number[]) => void): void => {
      this.addListenerFn(COORDINATE_EVENTS.COORDINATES_DELETE, listenerId, fn)
    },
    onCoordinatesSet: (listenerId: string, fn: (coordinates: ICoordinate[]) => void): void => {
      this.addListenerFn(COORDINATE_EVENTS.COORDINATES_SET, listenerId, fn)
    }
  }
}

export const coordinateEventModule: CoordinateEventModule = new CoordinateEventModule()
